import React, {Component} from "react";
import "./review.css";
import "bootstrap/dist/css/bootstrap.css";
import CommToolContext from "../../common/comm_tool_context";
import {getTeamRoleMembers} from "../../../api";
import {projectStatusMap} from "../../../components/ProjectStatusMap";
import styled from "styled-components";
import {Divider} from 'antd';
import {projectStatusCodeMap} from "../../../components/ProjectStatusCodeMap";
import {
    isCreatorOrAdministrator, isCreatorOrAdministratorOrInternalContributor,
    isInternalContributorOrViewOnly,
    isNotCreatorOrViewOnly,
    isViewOnly,
    userHasRoles
} from "../../../utils/UserInfo";
import ReactTooltip from "react-tooltip";

const TeamOverview = styled.div`
    overflow-y : scroll;
    overflow-x: hidden;
    height : 80px;
    padding-left: 0px;
`;

class Review extends Component {

    constructor(props) {
        super(props);
        this.getTooltipList = this.getTooltipList.bind(this);
        this.getDescTooltipList = this.getDescTooltipList.bind(this);
        this.state = {
            teamMembers: [],
            projectStatus: this.getProjectStatus(props.project)
        };
    }

    getProjectStatus(project) {
        return projectStatusMap[project.projectStatus]
    }

    async componentDidMount() {
        const teamMembers = await getTeamRoleMembers(this.props.project.id);
        this.setState({teamMembers})
    }

    getTooltipList = (list, obj) => {
        if(list === null || list.length === 0)
            return (<div></div>);
        if(list.length < 4)
        {
            return (
                <div>{list.map(desc => (
                    desc
                )).join(',')}</div>
            )
        }
        else if(list.length > 3) {
            return (
                <>
                     <div style={{alignItems: 'left',  width: (obj === 'WO' ? 270 : 275) }} data-tip data-for={'toolTip-'+obj}>
                        {list.slice(0,3).map(desc => (
                            desc)).join(', ')}{' ...'}
                    </div>
                    <ReactTooltip id={'toolTip-'+obj} place="bottom" effect="solid" textColor='black' backgroundColor='white' border={true} borderColor="black" type="info">
                        {list.map(item => (
                            item
                        )).join(', ')}
                    </ReactTooltip>
                </>
            )
        }
    }

    getDescTooltipList = (descriptions) => {
        if (descriptions && descriptions.length < 4) {
            return  descriptions.map((desc,index) => (
                <div>{index + 1}) {desc}</div>
            ))
        } else {
            return (
                <>
                    <div>
                        {
                            descriptions.slice(0,2).map((desc,index) => (
                                <div style={{alignItems: 'left'}}>{index + 1}) {desc}</div>))
                        }
                    </div>
                    <div  style={{alignItems: 'left', width: 320}} data-tip data-for="projectDescTip">
                        {'3) '}{descriptions[2]}{' ...'}</div>
                    <ReactTooltip id="projectDescTip" place="bottom" effect="solid" textColor='black' backgroundColor='white' border={true} borderColor="black" type="info">
                        {descriptions.map((item,index) => (
                            <div>{index + 1}) {item}</div>
                        ))}
                    </ReactTooltip>
                </>
            )
        }
    }

    getMemberList(role)
    {
        return (
            <td><b>{role.roleName}</b> : <span>{this.getMemberNames(role)}</span></td>
        )
    }
    getMemberNames(role)
    {

        
        let names = '';
        for(let i=0; i<role.teamDetails.length; ++i)
        {
            let name = role.teamDetails[i].team.firstName + ' ' + role.teamDetails[i].team.lastName;
            names += (name + ((role.teamDetails[i].hasApprovals === 'Y') ? '**' :
                ((role.teamDetails[i].isOnlyApprover === 'Y' || role.teamDetails[i].team.hasPCRole === 'Y') ? '*' : '')));
            if(i < role.teamDetails.length-1)
                names += ', ';
        }
        return names;
    }
    render() {
        const review = this.props.project;
        const bpids = review.bpid === null ? null : review.bpid.split(',');
        const mpids = review.mpid === null ? null : review.mpid.split(',');
        const workOrders = review.workOrder === null ? null : review.workOrder.split(',');
        const descriptions = review.relatedProjects.map(project => project.projectDescription);
        let teamMembers = this.props.teamMembers;
        if (!teamMembers || teamMembers.length === 0) {
            teamMembers = this.state.teamMembers;
        }
        return (
            <div className="contianer-fluid col-lg-12">
                <div style={{width: "100%", margin: "auto"}}/>

                <div className="spcard revcard">
                    <div className="revc-title">
                        <b>Project Details</b>
                        <div style={{flexGrow: 1}}/>
                        {
                        ((review.projectStatus === projectStatusCodeMap["DEVELOPMENT"] && isCreatorOrAdministrator()) ||
                            (review.projectStatus === projectStatusCodeMap["RELEASE"] && isCreatorOrAdministrator())) &&
                        <button
                            type="button"
                            className="w3-button btn-primary pull-right"
                            onClick={this.props.onEditProject}>
                            View Project Details
                        </button>
                        }
                        {((review.projectStatus === projectStatusCodeMap["CLOSED"]  && userHasRoles()) ||
                            (review.projectStatus === projectStatusCodeMap["DEVELOPMENT"] && !isCreatorOrAdministrator()) ||
                            (review.projectStatus === projectStatusCodeMap["ACTIVE"] && userHasRoles()) ||
                                (review.projectStatus === projectStatusCodeMap["RELEASE"] && !isCreatorOrAdministrator())) &&
                        <div>
                        <button type="button"
                                className="w3-button btn-primary pull-right"
                                onClick={this.props.onEditProject}>
                                View Project Details
                            </button>
                        </div>
                        }
                    </div>
                    <Divider className='hr-border'/>
                    <div className="card-text">
                        <div className="row">
                            <div className="col-xs-6">
                                <b>Project Description</b>
                                {review.linkProjectCount===0 ? <div>{review.projectDescription}</div> : this.getDescTooltipList(descriptions)}
                            </div>
                            <div className="col-xs-6">
                                <b>Station Region: </b> {review.stationRegion} <br/>
                                <b>TFS Station Area: </b> {review.tfStationArea} <br/>
                                <b>TFS P&C Area: </b> {review.pcArea}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                <b>BPID</b>
                                {this.getTooltipList(bpids, 'BPID')}
                                <br/>
                                <b>MPID</b>
                                {this.getTooltipList(mpids, 'MPID')}
                                <br/>
                                <b> Work Order</b>
                                {this.getTooltipList(workOrders, 'WO')}
                            </div>
                            <div className="col-xs-6">
                                <b>First Construction Start Date: </b> {review.constructionStartDate} <br/>
                                <b>Final In-Service Date: </b> {review.inServiceDate}
                            </div>
                        </div>
                        <br/>
                    </div>
                </div>

                <br/><br/>
                <div className="spcard revcard">
                    <div className="revc-title">
                        <b>Asset Summary</b>
                        <div style={{flexGrow: 1}}/>
                        {((review.projectStatus === projectStatusCodeMap["CLOSED"] && userHasRoles()) ||
                            (review.projectStatus === projectStatusCodeMap["DEVELOPMENT"] && userHasRoles()) ||
                            (review.projectStatus === projectStatusCodeMap["RELEASE"] && userHasRoles()) ||
                            (review.projectStatus === projectStatusCodeMap["ACTIVE"] && userHasRoles())) &&
                        <button type="button"
                                className="w3-button btn-primary pull-right"
                                onClick={this.props.onViewAsset}>
                            View Asset Details
                        </button>
                        }
                    </div>
                    <Divider className='hr-border'/>
                    <div className="card-text">
                        <div className="row">
                            <div className="col-md-12">
                                {
                                    (review.noOfAssets && review.noOfAssets > 0) ?
                                        (review.projectStatus === projectStatusCodeMap["RELEASE"] || review.projectStatus === projectStatusCodeMap["ACTIVE"]
                                        || review.projectStatus === projectStatusCodeMap["CLOSED"]) ?
                                        <div>
                                            Total of {review.noOfAssets} Assets <br/>
                                            Total of {review.noOfConductors} Conductors <br/>
                                            Total of {review.noOfSectionAssets} Assets Assigned Section(s) <br/>
                                            Total of {review.noOfFormAssets} Assets Assigned to Pre-E Form(s) <br/>
                                            {/* Total of {review.noOfConductorFormAssets} Conductors Assigned to Pre-E Form(s) <br/>  Wait until Release 2*/}
                                            Total of {review.noOfSections} Sections <br/>
                                            Total of {review.noOfSecLocations} Locations with Asset Tasks <br/>
                                        </div> :
                                            <div>
                                                Total of {review.noOfAssets} Assets <br/>
                                                Total of {review.noOfConductors} Conductors <br/>
                                                Total of {review.noOfSectionAssets} Assets Assigned Section(s) <br/>
                                                Total of {review.noOfSections} Sections <br/>
                                                Total of {review.noOfSecLocations} Locations with Asset Tasks <br/>
                                            </div>
                                            :
                                        <div>This project has no assets</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <br/> <br/>
                <div className="spcard revcard">
                    <div className="revc-title">
                        <b>Team </b>
                        <div style={{flexGrow: 1}}/>
                        {((review.projectStatus === projectStatusCodeMap["DEVELOPMENT"] && isCreatorOrAdministrator()) ||
                            (review.projectStatus === projectStatusCodeMap["RELEASE"] && isCreatorOrAdministratorOrInternalContributor()) ||
                            (review.projectStatus === projectStatusCodeMap["ACTIVE"] && isCreatorOrAdministratorOrInternalContributor())) &&
                        <button type="button"
                                className="w3-button btn-primary pull-right"
                                onClick={this.props.onEditTeam}>
                            Edit Team Members
                        </button>
                        }
                        {((review.projectStatus === projectStatusCodeMap["CLOSED"] && userHasRoles()) ||
                            (review.projectStatus === projectStatusCodeMap["DEVELOPMENT"] && !isCreatorOrAdministrator()) ||
                            (review.projectStatus === projectStatusCodeMap["RELEASE"] && !isCreatorOrAdministratorOrInternalContributor()) ||
                            (review.projectStatus === projectStatusCodeMap["ACTIVE"] && !isCreatorOrAdministratorOrInternalContributor())) &&
                        <button
                            type="button"
                            className="w3-button btn-primary pull-right"
                            onClick={this.props.onEditTeam}>
                            View Team Members
                        </button>
                        }

                    </div>
                    {(review.projectStatus === projectStatusCodeMap["RELEASE"]
                        || review.projectStatus === projectStatusCodeMap["ACTIVE"]) &&
                    <div>
                        <Divider className='hr-border'/>
                    <i className="fa fa-info-circle" style={{color:'red', paddingRight: '3px'}}
                       aria-hidden="true"></i><i><b>Note: Team Members identified on an Exception Form cannot be removed from the project. <br/>
                        (*=Exception Form Primary Contact or only Approver in that Role, and **=Exception Approver already responded to a Form)</b></i>
                    </div>}
                    <Divider className='hr-border'/>
                    <div className="card-text">
                        <div className="row">
                            <div className="col-md-12">
                                <table>
                                    <tbody>
                                    {teamMembers && teamMembers.map((role, index) => (
                                        <tr key={index}>
                                                 {this.getMemberList(role)}
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                            {" "}
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

Review.contextType = CommToolContext;

export default Review;
